const CONSENT_KEY = "asistentpersonal-cookie-consent"

export function getAnalyticsConsent() {
  try {
    const v = localStorage.getItem(CONSENT_KEY)
    return v === "accepted" ? "accepted" : v === "rejected" ? "rejected" : null
  } catch {
    return null
  }
}

export function setAnalyticsConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value)
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent("cookie-consent", { detail: value }))
}

let initStarted = false

/** Lazy-load PostHog only after explicit consent. */
export function initPosthogIfConsented() {
  if (getAnalyticsConsent() !== "accepted") return
  if (initStarted || (typeof window.posthog?.__loaded === "boolean" && window.posthog.__loaded)) {
    if (window.posthog?.opt_in_capturing) window.posthog.opt_in_capturing()
    return
  }
  const key = process.env.REACT_APP_POSTHOG_KEY
  if (!key) return
  initStarted = true

  !(function (t, e) {
    var o, n, p, r
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".")
          2 == o.length && ((t = t[o[0]]), (e = o[1]))
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
          }
        }
        ;((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r)
        var u = e
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog"
              return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e
            },
            u.people.toString = function () {
              return u.toString(1) + ".people (stub)"
            },
            o =
              "init capture register register_once identify reset get_distinct_id opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing".split(
                " "
              ),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n])
        e._i.push([i, s, a])
      }),
      (e.__SV = 1))
  })(document, window.posthog || [])

  window.posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    person_profiles: "identified_only",
    persistence: "localStorage+cookie",
    session_recording: {
      recordCrossOriginIframes: false,
      capturePerformance: false,
    },
    loaded: (ph) => {
      ph.__loaded = true
    },
  })
}

export function optOutPosthog() {
  try {
    if (window.posthog?.opt_out_capturing) window.posthog.opt_out_capturing()
  } catch {
    /* ignore */
  }
}
